module.exports = __webpack_public_path__ + "static/media/banner.c28d9299.png";